import {
  ADD_USER, FETCH_USER, SINGLE_USER, USER_PWD_CHG,
  UPDATE_USER, DELETE_USER,

  CLEAR_TEMP_USER, CLEAR_USER,
} from '../../../Helper/actionsTypes';

const userReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_USER: {
      return action.error
        ? { ...state, list: [] }
        : { ...state, list: action.payload };
    }
    case SINGLE_USER: {
      return action.error
        ? { ...state, single: {} }
        : { ...state, single: action.payload };
    }

    case DELETE_USER: {
      return action.error
        ? { ...state, itemDeleted: false }
        : { ...state, itemDeleted: true };
    }

    case ADD_USER: {
      return action.error
        ? { ...state, itemSaved: false, create: action.error }
        : { ...state, itemSaved: true, create: action.payload };
    }

    case UPDATE_USER: {
      return action.error
        ? { ...state, itemUpdated: false, update: action.error }
        : { ...state, itemUpdated: true, update: action.payload };
    }
    case USER_PWD_CHG: {
      if (action.payload.code === 200) return { ...state, pwdChange: true, message: action.payload.message }
      else return { ...state, pwdChange: false, message: action.payload.message }
    }

    case CLEAR_TEMP_USER: return { ...state, pwdChange: null, message: null };
    case CLEAR_USER: return {};
    default: return state;
  }
};

export default userReducer;